import type { TourTraveller } from "@getaways/core";
import type { ResosysTourBooking, TourBookingStatus } from "@getaways/tours";
import type { Tone } from "@getaways/extranet-ui";

export const STATUS: Record<TourBookingStatus, [Tone, string]> = {
  held: ["info", "held"],
  on_request: ["info", "on request"],
  waitlisted: ["info", "waitlisted"],
  confirmed: ["ok", "confirmed"],
  cancellation_requested: ["warn", "cancellation requested"],
  cancelled: ["bad", "cancelled"],
  expired: ["neutral", "expired"],
  failed: ["bad", "failed"],
  travelled: ["neutral", "travelled"],
};

export const AVAILABILITY: Record<string, [Tone, string]> = {
  available: ["ok", "available"],
  on_request: ["info", "on request"],
  waitlist: ["info", "waitlist"],
  sold_out: ["bad", "sold out"],
  closed: ["neutral", "closed"],
};

export const TASKS: Record<string, string> = {
  unpaid_balance: "Customer payment due",
  unpaid_supplier: "Supplier payment due",
  missing_traveller_data: "Missing traveller data",
  supplier_rejection: "Refused by the supplier",
  cancellation_pending: "Cancellation with the supplier",
  supplier_change: "Change at the supplier",
  reconciliation: "Reconciliation",
};

export const BRANDS: Record<string, string> = { "azores-getaways": "Azores Getaways", "portugal-getaways": "Portugal Getaways", "yes-getaways": "Yes Getaways" };

export const TITLES: Record<TourTraveller["title"], string> = { MR: "Mr", MRS: "Mrs", MS: "Ms", MISS: "Miss" };

export const MODES: Record<string, [Tone, string]> = {
  demo: ["warn", "Demo catalogue · simulated bookings"],
  live_read: ["info", "Live G Adventures prices · simulated bookings"],
  live: ["bad", "Live G Adventures · REAL bookings"],
};

export const lead = (b: ResosysTourBooking) => b.travellers[0];
